import { Spinner } from 'components/design';
import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/order-details-controller';
import DeatilsOrderView from '../components/details-order-view';

export const OrderDetailsRoute = () => {
    const { order, isLoading, isAdmin, handleBack } = useController();

    return (
        <OWContainer>
            {/* {isLoading ? <Spinner /> : <DetailView order={order} isAdmin={isAdmin} handleBack={handleBack} />} */}
            {isLoading ? <Spinner /> : <DeatilsOrderView order={order} isAdmin={isAdmin} handleBack={handleBack} />}
        </OWContainer>
    );
};
